const UserReview = () => import('@app/Review/UserReview')
const UserList = () => import('@app/Review/UserList')
const ReviewAdd = () => import('@app/Review/Add')
const ReviewSlimAdd = () => import('@app/Review/SlimAnswer')
const ReviewsMedia = () => import('@app/Review/Media')
const ReviewList = () => import('@app/Review/List')
const ClaimType = () => import('@app/Review/ClaimTypes')
const Liker = () => import('@app/Review/Liker')
const UnLiker = () => import('@app/Review/UnLiker')
const Detail = () => import('@app/Review/Detail')
const SellerDetail = () => import('@app/Review/SellerDetail')

export default function install(Vue) {
  Vue.component('ReviewDetail', Detail)
  Vue.component('ReviewSellerDetail', SellerDetail)
  Vue.component('Liker', Liker)
  Vue.component('UnLiker', UnLiker)
  Vue.component('ClaimType', ClaimType)
  Vue.component('UserReviewList', UserList)
  Vue.component('UserReview', UserReview)
  Vue.component('ReviewAdd', ReviewAdd)
  Vue.component('ReviewList', ReviewList)
  Vue.component('ReviewsMedia', ReviewsMedia)
  Vue.component('ReviewSlimAdd', ReviewSlimAdd)
}
